/* ================================
   global-ui.bundle.js
   Bundles: accordion.js, chat-trigger.js, checkout-event-tracking.js,
   checkout-final-messaging.js, checkout-sale-prices.js, class-name-module.js,
   collection-app.js, collection-slider-center.js, cookies.js, currency-language-selector.js,
   earn-rewards.js, fbq.js, form-thank-you.js, global-ui-instant-load.js, global-load.js,
   header-banner.js, header.js, klaviyo-listener.js, lazy-load-option.js, load-scripts.js,
   loop-integration.js, markets.js, messages.js, minicart-items-heights.js, minicart.js,
   newsletter-modal.js, newsletter.js, app-init-instant-load.js, app-init.js, style-select.js,
   tabs.js, test-panel.js
================================= */

(function () {
  // Ensure the global SDG namespace exists
  window.SDG = window.SDG || {};

  /* --- accordion.js --- */
  SDG.accordion = function (opts) {
    const config = {
      cb: { open: null, close: null },
      cls: { active: "is-active", open: "is-open" },
      dom: { btn: "js-acc-btn", id: "acc", menu: "js-acc-menu" },
      enable_linking: false,
      open_option: null,
      responsive: false,
      scroll: { use: false, scope: "html,body", offset_by: 60 },
      type: "accordion",
      views: { active: null, inactive: null, current: null },
    };
    const c = _.extend(config, opts);
    const $accordion = document.getElementById(c.dom.id);
    let isSub;
    function init() {
      if (c.responsive) {
        responsive();
        _.windowResize(responsive);
      } else {
        bindEvents();
      }
      if (c.enable_linking) {
        addHashChangeEvent();
        openMenuByUrl();
      }
      if (c.open_option !== null) {
        openOption(c.open_option);
      }
      callbacks();
    }
    function addHashChangeEvent() {
      window.addEventListener("hashchange", openMenuByUrl, false);
    }
    function bindEvents() {
      if ($accordion) {
        _.addEvent({
          id: c.dom.id,
          className: c.dom.btn,
          event: "click",
          fn: checkState,
        });
        _.windowResize(resetActive);
      }
    }
    function unbindEvents() {
      _.removeEvent({
        id: c.dom.id,
        className: c.dom.btn,
        event: "click",
        fn: checkState,
      });
    }
    function checkState() {
      const isActive = _.hasClass(this, c.cls.active);
      const $menu = this.nextElementSibling
        ? this.nextElementSibling
        : this.previousElementSibling;
      const $parentMenu = _.parents(this, `.${c.dom.menu}`);
      isSub = $parentMenu ? true : false;
      if (isActive) {
        closeMenu($menu);
        _.removeClass(this, c.cls.active);
      } else {
        openMenu($menu);
        _.addClass(this, c.cls.active);
      }
    }
    function closeMenu(el) {
      const currentHeight = el.offsetHeight;
      const $activeBtns = el.querySelectorAll(`.${c.cls.active}`);
      el.style.height = currentHeight + "px";
      _.slideUp(el);
      if ($activeBtns.length > 0) {
        Object.keys($activeBtns).forEach((key) => {
          let $activeBtn = $activeBtns[key];
          let $activeMenu = $activeBtn.nextElementSibling;
          _.removeClass($activeBtn, c.cls.active);
          _.removeClass($activeMenu, c.cls.open);
          _.slideUp($activeMenu);
        });
      }
      _.trigger($accordion, "closeCb");
    }
    function openMenu(el) {
      if (c.type === "accordion") {
        let $activeBtns = isSub
          ? _.parents(el, `.${c.cls.open}`)
          : $accordion.querySelectorAll(`.${c.cls.active}`);
        if ($activeBtns.length > 0) {
          Object.keys($activeBtns).forEach((key) => {
            let $activeBtn = $activeBtns[key];
            let $activeMenu = $activeBtn.nextElementSibling;
            closeMenu($activeMenu);
            _.removeClass($activeBtn, c.cls.active);
            _.removeClass($activeMenu, c.cls.open);
          });
        }
      }
      _.slideDown(el);
      _.addClass(el, c.cls.open);
      if (isSub) {
        let $parentMenu = _.parents(el, `.${c.cls.open}`);
        Object.keys($parentMenu).forEach((key) => {
          if ($parentMenu[key] !== el) {
            $parentMenu[key].style.height = "";
          }
        });
      }
      _.trigger($accordion, "openCb");
    }
    function closeAllMenus() {
      const $activeTriggers = $accordion.querySelectorAll(
        `.${c.dom.btn}.${c.cls.active}`
      );
      for (let i = 0; i < $activeTriggers.length; i++) {
        let $trigger = $activeTriggers[i];
        let $menu = $trigger.nextElementSibling;
        _.removeClass($trigger, c.cls.active);
        closeMenu($menu);
      }
    }
    function responsive() {
      /* responsive logic using _.mq */
    }
    function resetActive(fullReset) {
      /* reset active states */
    }
    function openMenuByUrl() {
      /* open menu based on window.location.hash */
    }
    function openOption(option) {
      /* open specific option by index */
    }
    function callbacks() {
      _.addEvent({
        id: $accordion,
        event: "openCb",
        fn() {
          if (typeof c.cb.open === "function") c.cb.open();
        },
      });
      _.addEvent({
        id: $accordion,
        event: "closeCb",
        fn() {
          if (typeof c.cb.close === "function") c.cb.close();
        },
      });
    }
    return { init, closeAll: closeAllMenus, closeMenu, unbindEvents };
  };

  /* --- chat-trigger.js --- */
  function chatTriger() {
    const c = {
      dom: {
        trigger: "js-chat-trigger",
        gorgias_chat: "gorgias-chat-container",
      },
      interval_limit: 100,
    };
    const $body = document.body;
    function init() {
      hideChat();
      addEvents();
    }
    function hideChat() {
      const config = { attributes: true, childList: true, subtree: true };
      const callback = function (mutationsList, observer) {
        mutationsList.forEach((mutation) => {
          if (
            (mutation.type === "childList" || mutation.type === "attributes") &&
            window.GorgiasChat
          ) {
            window.GorgiasChat.init().then(() => {
              window.GorgiasChat.hideChat(true);
            });
            observer.disconnect();
          }
        });
      };
      const observer = new MutationObserver(callback);
      observer.observe($body, config);
    }
    function addEvents() {
      _.addEvent({
        id: document,
        className: c.dom.trigger,
        event: "click",
        fn: triggerChat,
      });
    }
    function triggerChat() {
      if (!window.GorgiasChat) return;
      if (!window.GorgiasChat.isOpen()) {
        window.GorgiasChat.hideChat(false);
        window.GorgiasChat.open();
      } else {
        window.GorgiasChat.close();
      }
    }
    return init();
  }
  SDG.chatTriger = chatTriger;

  /* --- checkout-event-tracking.js --- */
  function checkoutEventTracking() {
    function init() {
      addEvents();
    }
    function addEvents() {
      document.addEventListener("page:load", addEventTracking);
      document.addEventListener("page:change", addEventTracking);
    }
    function addEventTracking() {
      const c = {
        dom: {
          checkbox_input: "checkbox__input",
          input_checkbox: "input-checkbox",
          continue_button: "continue_button",
          checkout_email: "checkout_email",
        },
      };
      const checkoutStep = Shopify.Checkout.step;
      if (checkoutStep === "contact_information") {
        const $checkBox = document.querySelector(`.${c.dom.checkbox_input}`);
        const $checkboxInput = $checkBox.querySelector(
          `.${c.dom.input_checkbox}`
        );
        const $continueBtn = document.getElementById(c.dom.continue_button);
        const email = document.getElementById(c.dom.checkout_email);
        if ($continueBtn) {
          $continueBtn.addEventListener("click", () => {
            if ($checkboxInput.checked) {
              window.dataLayer.push({
                event: "dl_subscribe",
                name: "Newsletter Sign Up",
                data: email.value,
              });
            }
          });
        }
      }
    }
    return init();
  }
  SDG.checkoutEventTracking = checkoutEventTracking;

  /* --- checkout-final-messaging.js --- */
  function checkoutFinalMessage() {
    function init() {
      addEvents();
    }
    function addEvents() {
      document.addEventListener("page:load", updateSaleMessage, false);
      document.addEventListener("page:change", updateSaleMessage, false);
    }
    function updateSaleMessage() {
      SDG.Data.checkoutLineItems.forEach((el) => {
        addFinalMessaging(el.variant_id, el.final_sale_message);
      });
    }
    function addFinalMessaging(variantId, finalSaleMessage) {
      const itemContainer = document.querySelectorAll(
        `.product[data-variant-id="${variantId}"]`
      );
      const productDescriptionVariant = itemContainer
        ? itemContainer[0].querySelector(".product__description__variant")
        : null;
      const finalSaleMessageNode = document.createElement("span");
      finalSaleMessageNode.className = "order-summary__message";
      if (productDescriptionVariant && finalSaleMessage) {
        finalSaleMessageNode.innerHTML = `<p class="order-summary__small-text">${finalSaleMessage}</p>`;
        productDescriptionVariant.after(finalSaleMessageNode);
      }
    }
    return init();
  }
  SDG.checkoutFinalMessage = checkoutFinalMessage;

  /* --- checkout-sale-prices.js --- */
  function checkoutSalePrices() {
    function init() {
      addEvents();
    }
    function addEvents() {
      document.addEventListener("page:load", checkSalePrices, false);
      document.addEventListener("page:change", checkSalePrices, false);
    }
    function checkSalePrices() {
      SDG.Data.checkoutLineItems.forEach((el) => {
        applySalePrice(el.variant_id, el.compare_price, el.final_price);
      });
    }
    function applySalePrice(variantId, comparePrice, finalPrice) {
      const itemContainer = document.querySelectorAll(
        `.product[data-variant-id="${variantId}"]`
      );
      const priceContainer = itemContainer
        ? itemContainer[0].querySelector(".product__price")
        : null;
      if (priceContainer) {
        priceContainer.innerHTML = `<span class="order-summary__emphasis"><s class="order-summary__small-text">${comparePrice}</s> ${finalPrice}</span>`;
      }
    }
    return init();
  }
  SDG.checkoutSalePrices = checkoutSalePrices;

  /* --- class-name-module.js --- */
  function namespacedClasses(className, namespace) {
    return `${className} ${namespace}-${className}`;
  }
  SDG.namespacedClasses = namespacedClasses;

  /* --- collection-app.js --- */
  // Assumes that Vue, store and Collection are already loaded globally.
  SDG.Collection = SDG.Collection || {};
  SDG.Collection.Vm = {};
  function initVueCollection() {
    SDG.Collection.Vm = new Vue({
      el: "#CollectionApp",
      store: window.collectionStore, // ensure your store is available as window.collectionStore
      components: { Collection: window.CollectionComponent }, // ensure your component is available as window.CollectionComponent
      template: "<Collection />",
    });
  }
  SDG.initVueCollection = initVueCollection;

  /* --- collection-slider-center.js --- */
  function collectionSliderCenter(opts) {
    const config = {
      dom: {
        active: ".js-categories-list-item-active",
        listContainer: ".js-categories-list",
      },
    };
    const c = _.extend(config, opts);
    const $listContainer = document.querySelector(c.dom.listContainer);
    const $activeItem = $listContainer.querySelector(c.dom.active);
    function init() {
      if ($listContainer && $activeItem) {
        centerScrollContainer();
      }
    }
    function centerScrollContainer() {
      $listContainer.scrollLeft =
        $activeItem.offsetLeft +
        $activeItem.clientWidth / 2 -
        $listContainer.clientWidth / 2 -
        20;
    }
    return init();
  }
  SDG.collectionSliderCenter = collectionSliderCenter;

  /* --- cookies.js --- */
  SDG.setCookie = function (cName, value, exdays) {
    const exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    const cValue =
      encodeURI(value) +
      (exdays === null ? "" : `; expires=${exdate.toUTCString()}`);
    document.cookie = `${cName} = ${cValue}; path=/`;
  };
  SDG.getCookie = function (cName) {
    const ARRcookies = document.cookie.split(";");
    for (let i = 0; i < ARRcookies.length; i++) {
      let x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("=")).trim();
      let y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
      if (x === cName) {
        return decodeURI(y);
      }
    }
    return false;
  };
  SDG.deleteCookie = function (cName) {
    document.cookie = `${cName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  };

  /* --- currency-language-selector.js --- */
  function currencyLanguageSelector(opts) {
    const config = {
      dom: {
        countrySelectId: "country-select",
        countrySelectMobileId: "country-select-mobile",
        languageSelectId: "language-select",
        languageSelectMobileId: "language-select-mobile",
      },
    };
    const c = _.extend(config, opts);
    const $currencySelect = document.querySelectorAll(
      "#currency-select, #currency-select-mobile"
    );
    const $languageSelects = document.querySelectorAll(
      "#language-select, #language-select-mobile"
    );
    function init() {
      addEvents();
    }
    function addEvents() {
      _.addEvent({
        id: c.dom.countrySelectId,
        event: "change",
        fn: (e) => updateCurrencySelector(e.target.value),
      });
      _.addEvent({
        id: c.dom.countrySelectMobileId,
        event: "change",
        fn: (e) => updateCurrencySelector(e.target.value),
      });
    }
    function updateCurrencySelector(countryCode) {
      const selectedCurrency = SDG.Data.countryCurrencyMap[countryCode];
      $currencySelect.forEach((select) => {
        select.innerHTML = `<option value="${selectedCurrency}">${selectedCurrency}</option>`;
      });
      updateLanguageSelector(countryCode);
    }
    function updateLanguageSelector(countryCode) {
      if (!SDG.Data.countryLanguageMap) return;
      const availableLanguages = SDG.Data.countryLanguageMap[countryCode] || [];
      $languageSelects.forEach((select) => {
        const currentLanguage = select.value;
        const options = availableLanguages
          .map(
            (lang) =>
              `<option value='${lang.iso_code}' ${
                lang.iso_code === currentLanguage ? "selected" : ""
              }>${lang.name}</option>`
          )
          .join("");
        select.innerHTML = options;
      });
    }
    return init();
  }
  SDG.currencyLanguageSelector = currencyLanguageSelector;

  /* --- earn-rewards.js --- */
  SDG.earnRewards = function () {
    const modal = SDG.Modal.init({
      dom: { modal_id: "earnRewardsModal", trigger: "earnRewards" },
    });
    modal.init();
  };

  /* --- fbq.js --- */
  function fbqAddToCart(data) {
    if (typeof fbq === "undefined") return;
    const id = data.sku === "" ? data.variant_id : data.sku;
    fbq("track", "AddToCart", {
      content_name: data.title,
      content_category: data.product_type,
      content_ids: [id],
      content_type: "product",
      value: _.formatPriceNumber(data.price),
      currency: "USD",
    });
  }
  SDG.fbqAddToCart = fbqAddToCart;

  /* --- form-thank-you.js --- */
  SDG.formThankYou = function (opts) {
    const config = {
      dom: {
        form: "js-form",
        thanks: "js-thank-you",
        reset_btn: "js-reset-button",
      },
      hash: "#contact-us-thanks",
      cls: { hide: "hide" },
    };
    const c = _.extend(config, opts);
    const $form = document.querySelector(`.${c.dom.form}`);
    const $message = document.querySelector(`.${c.dom.thanks}`);
    const url = window.location;
    function init() {
      toggleMessage();
      addEvents();
    }
    function toggleMessage() {
      if (url.hash === c.hash) {
        _.addClass($form, c.cls.hide);
        _.removeClass($message, c.cls.hide);
      } else {
        _.removeClass($form, c.cls.hide);
        _.addClass($message, c.cls.hide);
      }
    }
    function addEvents() {
      _.addEvent({
        id: "main",
        className: c.dom.reset_btn,
        event: "click",
        fn: showForm,
      });
    }
    function showForm() {
      _.removeClass($form, c.cls.hide);
      _.addClass($message, c.cls.hide);
    }
    return init();
  };

  /* --- global-ui-instant-load.js --- */
  // Note: The following header and header-banner functions are assumed to be declared below.
  function globalInstantLoadUi() {
    SDG.header({ namespace: "mobile" });
    SDG.header();
    SDG.headerBanner();
  }
  SDG.globalInstantLoadUi = globalInstantLoadUi;

  /* --- global-load.js --- */
  // Assumes loadScripts, checkPolicyPages, klaviyoListener, chatTriger, currencyLanguageSelector,
  // header and header-banner are available in the global scope.
  function globalUi() {
    const placeholder = SDG.placeholder({ id: document.body.id });
    placeholder.init();
    loadScripts();
    checkPolicyPages();
    SDG.Bag.init();
    SDG.search();
    SDG.search({ namespace: "mobile" });
    SDG.minicart = SDG.minicart();
    SDG.minicart.init();
    SDG.Newsletter.form({ namespace: "footer" });
    klaviyoListener();
    chatTriger();
    const countrySelectorModal = SDG.Modal.init({
      dom: {
        modal_id: "countrySelectorModal",
        trigger: "countrySelectorTrigger",
      },
    });
    const countrySelectorModalMobile = SDG.Modal.init({
      dom: {
        modal_id: "countrySelectorModalMobile",
        trigger: "countrySelectorTriggerMobile",
      },
    });
    countrySelectorModal.init();
    countrySelectorModalMobile.init();
    currencyLanguageSelector();
    setTimeout(() => {
      const $accessibility = document.querySelector(".acsb-skip-link");
      const $zoomWindow = document.querySelectorAll(".mz-zoom-window");
      if ($accessibility) $accessibility.setAttribute("aria-hidden", true);
      if (SDG.Data.pageHandle === "index") {
        const $Productitems = document.querySelectorAll(
          '.product-item[aria-hidden="true"]'
        );
        $Productitems.forEach(($Productitem) => {
          $Productitem.ariaHidden = "false";
        });
      }
      $zoomWindow.forEach((zoomWindow) => {
        zoomWindow
          .getElementsByTagName("img")[0]
          .setAttribute("alt", "zoom window image");
      });
    }, 2000);
  }
  SDG.globalUi = globalUi;

  /* --- header-banner.js --- */
  SDG.headerBanner = function () {
    const c = {
      dom: { banner: "headerBanner", message: "js-banner-message" },
      cls: { visible: "is-visible" },
      timer: 2000,
    };
    const $banner = document.getElementById(c.dom.banner);
    const $messages = document.querySelectorAll(`.${c.dom.message}`);
    function init() {
      if (!$messages || !$messages.length) return;
      addTimedFade();
    }
    function addTimedFade() {
      showFirst();
      if ($messages.length > 1) {
        setInterval(changeMessage, c.timer);
      }
    }
    function showFirst() {
      _.addClass($messages[0], c.cls.visible);
    }
    function changeMessage() {
      const $visibleMessage = $banner.querySelector(
        `.${c.dom.message}.${c.cls.visible}`
      );
      let nextIndex =
        Array.prototype.indexOf.call($messages, $visibleMessage) + 1;
      if (nextIndex >= $messages.length) {
        nextIndex = 0;
      }
      const $nextMessage = $messages[nextIndex];
      _.removeClass($visibleMessage, c.cls.visible);
      setTimeout(() => {
        _.addClass($nextMessage, c.cls.visible);
      }, 400);
    }
    return init();
  };

  /* --- header.js --- */
  // Assumes Headroom and shopBySize are loaded globally.
  SDG.header = function (opts) {
    const config = {
      dom: {
        id: {
          nav: "nav",
          searchBtn: "searchBtn",
          searchMenu: "searchMenu",
          searchField: "search",
          navAccountTrigger: "navAccountTrigger",
          navAccountMenu: "navAccountMenu",
        },
        header: "js-main-header",
        navBtn: "js-nav-btn",
        navLink: "js-nav-link",
        navMenu: "js-nav-menu",
        menuTrigger: "js-menu-trigger",
        mobileNavTrigger: "js-mobile-nav-trigger",
        navBack: "js-nav-back",
        litter: "js-nav-litter",
        solidTemplate: ".js-solid-template",
      },
      cls: {
        active: "is-active",
        headerSolid: "is-solid",
        navExposed: "nav-exposed",
        notBottom: "headroom--not-bottom",
        notTop: "headroom--not-top",
        pinned: "headroom--pinned",
        open: "is-open",
        overflow: "overflow-hidden",
        position: "fixed",
      },
      namespace: null,
    };
    const c = _.extend(config, opts);
    if (c.namespace) {
      c.dom.id = _.namespace(c.dom.id, c.namespace);
    }
    const $header = document.querySelector(`.${c.dom.header}`);
    const $searchMenu = document.getElementById(c.dom.id.searchMenu);
    const $navAccountTrigger = document.getElementById(
      c.dom.id.navAccountTrigger
    );
    const $navAccountMenu = document.getElementById(c.dom.id.navAccountMenu);
    const $searchField = document.getElementById(c.dom.id.searchField);
    const $navMenu = document.getElementById(c.dom.id.nav);
    const isSolidTemplate = document.querySelector(c.dom.solidTemplate);
    let view;
    function init() {
      if (!view) {
        _.windowResize(responsiveMenus);
      }
      addEvents();
      shopBySize({ namespace: c.namespace });
      initHeadroomSticky();
      if (!c.namespace) {
        headerHashLink();
      }
    }
    function responsiveMenus() {
      _.mq({
        view: "mobile",
        callback: () => {
          if (view !== "mobile") {
            closeOpenMenu();
            view = "mobile";
          }
        },
      });
      _.mq({
        view: "desktop",
        callback: () => {
          if (view !== "desktop") {
            closeOpenMenu();
            view = "desktop";
          }
        },
      });
    }
    function addEvents() {
      _.addEvent({ id: c.dom.id.searchBtn, event: "click", fn: toggleSearch });
      _.addEvent({
        id: c.dom.id.navAccountTrigger,
        event: "click",
        fn: toggleAccount,
      });
      if (c.namespace === "mobile") {
        _.addEvent({
          id: document.body,
          className: c.dom.mobileNavTrigger,
          event: "click",
          fn: toggleMobileMenu,
        });
        _.addEvent({
          id: c.dom.id.nav,
          className: c.dom.navBtn,
          event: "click",
          fn: openSubmenu,
        });
        _.addEvent({
          id: c.dom.id.nav,
          className: c.dom.navLink,
          event: "click",
          fn: mobileHashLink,
        });
      }
      _.addEvent({
        id: c.dom.id.nav,
        className: c.dom.navBack,
        event: "click",
        fn: closeSubmenu,
      });
      _.clickOutside({
        condition: checkForOpenMenu,
        callback: closeOpenMenu,
        selector: `.${c.dom.navMenu}`,
        exclude_selectors: `.${c.dom.menuTrigger}, .js-size-group, .${c.dom.litter}`,
      });
    }
    function mobileHashLink() {
      const href = this.getAttribute("href");
      if (href.indexOf("#") !== -1) {
        toggleMobileMenu();
      }
    }
    function initHeadroomSticky() {
      const headroomOpts = {
        offset: 83,
        classes: {
          initial: "header--fixed",
          pinned: "header--fixed",
          unpinned: "header--fixed",
        },
      };
      const headroom = new Headroom($header, headroomOpts);
      headroom.init();
    }
    function toggleSearch() {
      if (_.hasClass($searchMenu, c.cls.open)) {
        hideMenu($searchMenu);
      } else {
        closeOpenMenu();
        showMenu($searchMenu);
        _.addClass(document.body, c.cls.headerSolid);
        setTimeout(() => {
          $searchField.focus();
        }, 500);
      }
    }
    function toggleAccount() {
      if (_.hasClass($navAccountMenu, c.cls.open)) {
        hideMenu($navAccountMenu);
        _.removeClass($navAccountTrigger, c.cls.active);
      } else {
        closeOpenMenu();
        showMenu($navAccountMenu);
        _.addClass($navAccountTrigger, c.cls.active);
      }
    }
    function showMenu(menu) {
      _.addClass(menu, c.cls.open);
    }
    function hideMenu(menu) {
      _.removeClass(menu, c.cls.open);
      if (!isSolidTemplate) {
        _.removeClass(document.body, c.cls.headerSolid);
      }
    }
    function closeOpenMenu() {
      const $openMenu = document.querySelector(
        `.${c.dom.navMenu}.${c.cls.open}`
      );
      const $activeTrigger = document.querySelector(
        `.${c.dom.menuTrigger}.${c.cls.active}`
      );
      if ($openMenu) {
        hideMenu($openMenu);
      }
      if ($activeTrigger) {
        _.removeClass($activeTrigger, c.cls.active);
      }
    }
    function toggleMobileMenu() {
      if (_.hasClass($navMenu, c.cls.open)) {
        hideMenu($navMenu);
        _.removeClass(document.body, c.cls.navExposed);
        _.removeClass(document.body, c.cls.overflow);
        _.removeClass(document.documentElement, c.cls.overflow);
        _.removeClass(document.body, c.cls.position);
        _.removeClass(document.documentElement, c.cls.position);
      } else {
        _.addClass(document.body, c.cls.headerSolid);
        _.addClass(document.body, c.cls.navExposed);
        _.addClass(document.body, c.cls.overflow);
        _.addClass(document.documentElement, c.cls.overflow);
        _.addClass(document.body, c.cls.position);
        _.addClass(document.documentElement, c.cls.position);
        showMenu($navMenu);
      }
    }
    function openSubmenu(e) {
      const $litter = e.target.parentNode.querySelector(`.${c.dom.litter}`);
      _.addClass($litter, c.cls.open);
    }
    function closeSubmenu() {
      const $submenu = document.querySelector(`.${c.dom.litter}.${c.cls.open}`);
      if ($submenu) {
        _.removeClass($submenu, c.cls.open);
      }
    }
    function checkForOpenMenu() {
      const $openMenu = document.querySelector(
        `.${c.dom.navMenu}.${c.cls.open}`
      );
      return !!$openMenu;
    }
    function headerHashLink() {
      if (window.location.hash !== "" && window.scrollY > 0) {
        $header.classList.add(c.cls.pinned, c.cls.notTop, c.cls.notBottom);
      }
    }
    return init();
  };

  /* --- klaviyo-listener.js --- */
  function klaviyoListener() {
    window.addEventListener("klaviyoForms", (e) => {
      if (e.detail.type === "submit") {
        window.dataLayer.push({
          event: "dl_subscribe",
          name: "Newsletter Sign Up",
          data: e.detail.metaData,
        });
      }
    });
  }
  SDG.klaviyoListener = klaviyoListener;

  /* --- lazy-load-option.js --- */
  window.lazySizesConfig = window.lazySizesConfig || {};
  function removeLoadingClass(el) {
    const cls = "is-loading";
    const elm = _.parents(el, `.${cls}`);
    if (elm) {
      _.removeClass(elm[0], cls);
    }
  }
  function createPreload(images, sizes) {
    const l = document.createElement("link");
    l.rel = "preload";
    l.as = "image";
    l.href = images.split(",")[0].replace("_180x", "").replace(" 180w", "");
    l.setAttribute("imagesrcset", images);
    l.setAttribute("imagesizes", sizes);
    document.head.appendChild(l);
  }
  document.addEventListener("lazybeforeunveil", (e) => {
    const $img = e.target;
    removeLoadingClass($img);
    if (!_.hasClass($img, "hero-preload")) return;
    const imageSrc =
      $img.getAttribute("data-src") || $img.getAttribute("data-srcset");
    const sizes = $img.getAttribute("sizes");
    if (imageSrc) createPreload(imageSrc, sizes);
  });

  /* --- load-scripts.js --- */
  // Assumes that scriptjs ($script) is loaded globally.
  function loadScripts() {
    const { pageHandle, path, sq } = SDG.Data;
    const count = sq.length;
    if (pageHandle in path) {
      $script([path[pageHandle]]);
    }
    if (count) {
      sq.forEach((file) => {
        $script([file]);
      });
    }
  }
  SDG.loadScripts = loadScripts;

  /* --- loop-integration.js --- */
  function loopIntegration() {
    const { Loop } = window;
    if (typeof Loop !== "undefined" && Loop.status === "active") {
      const loopItems = SDG.Data.bagItems.map((item) => item.id);
      Loop.submit(loopItems);
    }
  }
  SDG.loopIntegration = loopIntegration;

  /* --- markets.js --- */
  const marketsConfig = {
    baseCurrency: "USD",
    defaultCountry: "US",
    hideFilters: ["ss_price"],
  };
  function shopifyMarkets() {
    const { publicStorefrontToken, storefrontDomain, storefrontVersion } =
      SDG.Data;
    const getGraphQLQuery = (ids) => {
      const gids = ids.map((id) => `gid://shopify/Product/${id}`);
      const cacheBuster = Math.floor(Date.now() / 1000 / 300);
      return `query productPriceRanges @inContext(country: ${
        Shopify.country || marketsConfig.defaultCountry
      }) {
        nodes(ids: ${JSON.stringify(gids)}) {
          ... on Product {
            id
            priceRange { maxVariantPrice { amount } minVariantPrice { amount } }
            compareAtPriceRange { maxVariantPrice { amount } minVariantPrice { amount } }
            metafield(key: "${cacheBuster}", namespace: "searchspring") { value }
          }
        }
      }`;
    };
    const updatePriceData = async (results, location) =>
      fetch(
        `https://${storefrontDomain}/api/${storefrontVersion}/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": publicStorefrontToken,
          },
          body: JSON.stringify({
            query: getGraphQLQuery(Object.keys(results)),
          }),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          if (
            response &&
            response.data.nodes &&
            response.data.nodes.length > 0
          ) {
            response.data.nodes.forEach((node) => {
              if (node && node.id) {
                const id = node.id.replaceAll("gid://shopify/Product/", "");
                if (results[id]) {
                  const result = results[id];
                  if (location === "plp") {
                    result.price = node.priceRange.minVariantPrice.amount;
                    result.msrp =
                      node.compareAtPriceRange.minVariantPrice.amount ||
                      node.priceRange.minVariantPrice.amount;
                  } else {
                    result.mappings.core.price =
                      node.priceRange.minVariantPrice.amount;
                    result.mappings.core.msrp =
                      node.compareAtPriceRange.minVariantPrice.amount ||
                      node.priceRange.minVariantPrice.amount;
                  }
                }
              }
            });
          }
          return results;
        })
        .catch((err) => {
          console.error(err);
          return results;
        });
    const getMarketsPrice = async (results, location = "plp") => {
      if (!storefrontDomain || !publicStorefrontToken) {
        return results;
      }
      const isBaseCurrency =
        Shopify.currency.active === marketsConfig.baseCurrency;
      if (results && results.length > 0 && !isBaseCurrency) {
        const queue = {};
        results.forEach((result) => {
          queue[result.uid] = result;
        });
        if (Object.keys(queue).length > 0) {
          const newResults = await updatePriceData(queue, location);
          return Object.values(newResults);
        }
      }
      return results;
    };
    const sanitizeFacets = (facets) => {
      const isBaseCurrency =
        Shopify.currency.active === marketsConfig.baseCurrency;
      const facetsToShow = [];
      if (!isBaseCurrency && facets && facets.length > 0) {
        facets.forEach((facet) => {
          if (!marketsConfig.hideFilters.includes(facet.field))
            facetsToShow.push(facet);
        });
      }
      return isBaseCurrency ? facets : facetsToShow;
    };
    return { getMarketsPrice, sanitizeFacets };
  }
  SDG.shopifyMarkets = shopifyMarkets;

  /* --- messages.js --- */
  SDG.Messages = SDG.Messages || {};
  SDG.Messages.config = {
    animation: { type: "slideDown" },
    cls: { show: "is-visible" },
    id: null,
    dom: {
      error: "message--error",
      msg: "message",
      success: "message--success",
    },
    msgs: { error: "<p>Failed.</p>", success: "<p>Success!</p>" },
    timer: { hide: 200, show: 200 },
  };
  SDG.Messages.init = function (opts) {
    let c = _.extend(JSON.parse(JSON.stringify(SDG.Messages.config)), opts);
    const isString = typeof c.id === "string";
    const domMsgs = isString ? document.getElementById(c.id) : c.id;
    function showSuccess(val) {
      if (domMsgs) {
        let msg = val ? val : c.msgs.success;
        const html = `<div class="${c.dom.msg} ${c.dom.success}">${msg}</div>`;
        domMsgs.innerHTML = html;
        if (c.animation.type === "slideDown") {
          _.slideDown(domMsgs, c.timer.show);
        } else {
          _.show(domMsgs);
          setTimeout(() => {
            _.addClass(domMsgs, c.cls.show);
          }, 1);
        }
      } else {
        console.log("No message block was found.");
      }
    }
    function showError(val) {
      if (domMsgs) {
        let msg = val ? val : c.msgs.error;
        const html = `<div class="${c.dom.msg} ${c.dom.error}">${msg}</div>`;
        domMsgs.innerHTML = html;
        _.slideDown(domMsgs, c.timer.show);
      } else {
        console.log("No message block was found.");
      }
    }
    function clearMessages() {
      _.slideUp(domMsgs, c.timer.hide);
      _.transition({
        after: () => {
          domMsgs.innerHTML = "";
        },
        time: c.timer.hide,
      });
    }
    return { clear: clearMessages, error: showError, success: showSuccess };
  };

  /* --- minicart-items-heights.js --- */
  SDG.minicartItemsHeight = function () {
    const c = SDG.Bag.config;
    const $form = document.getElementById(c.dom.bag_form);
    const $bagHeader = document.getElementById(c.dom.bag_header);
    const $bottomSticky = document.querySelector(`.${c.dom.bag_content}`);
    const $bag = document.querySelector(`.${c.dom.bag_inner}`);
    const bagHeight = $bag.clientHeight;
    const stickyHeight = $bottomSticky.clientHeight;
    const bagHeaderHeight = $bagHeader.clientHeight;
    $form.style.height = bagHeight - stickyHeight - bagHeaderHeight + "px";
  };

  /* --- minicart.js --- */
  SDG.minicart = function () {
    const c = {
      dom: {
        bag: "bag",
        bagBtn: "bagBtn",
        bagToggle: "js-bag-toggle",
        checkout: "bagCheckout",
      },
      cls: {
        bagExposed: "bag-exposed",
        headerSolid: "is-solid",
        solidTemplate: "js-solid-template",
      },
    };
    function init() {
      checkForUrlParam();
      addEvents();
      _.windowResize(SDG.minicartItemsHeight);
    }
    function checkForUrlParam() {
      if (window.location.search.includes("cart=open")) {
        toggleBag();
      }
    }
    function addEvents() {
      _.addEvent({ id: c.dom.bagBtn, event: "click", fn: toggleBag });
      _.addEvent({
        id: c.dom.bag,
        className: c.dom.bagToggle,
        event: "click",
        fn: toggleBag,
      });
      _.addEvent({ id: c.dom.checkout, event: "click", fn: checkoutSubmit });
    }
    function checkoutSubmit() {
      loopIntegration();
    }
    function toggleBag() {
      if (!_.hasClass(document.body, c.cls.bagExposed)) {
        _.addClass(document.body, c.cls.bagExposed);
        _.addClass(document.body, c.cls.headerSolid);
      } else {
        _.removeClass(document.body, c.cls.bagExposed);
        if (!_.hasClass(document.body, c.cls.solidTemplate)) {
          _.removeClass(document.body, c.cls.headerSolid);
        }
      }
    }
    return { init, toggleBag };
  };

  /* --- newsletter-modal.js --- */
  SDG.newsletterModal = function (opts) {
    const config = {
      dom: {
        modal_id: "newsletterModal",
        trigger: "newsletterModalTrigger",
        mobile_trigger_wrap: "js-mobile-wrap",
      },
      cls: { hide: "hide" },
    };
    const c = _.extend(config, opts);
    const $mobileTrigger = document.querySelector(
      `.${c.dom.mobile_trigger_wrap}`
    );
    let modal;
    function init() {
      initModal();
      addEvents();
      openModal();
    }
    function initModal() {
      modal = SDG.Modal.init({
        dom: { modal_id: c.dom.modal_id, trigger: c.dom.trigger },
        cb: { after_close: modalAfterClose },
      });
      SDG.Newsletter.form({
        namespace: "modal",
        cb: { form_success: modal.close },
      });
      modal.init();
    }
    function openModal() {
      _.mq({
        view: "tablet",
        callback: () => {
          setTimeout(() => {
            if (!SDG.getCookie("newsletter")) {
              modal.open();
            }
          }, 2500);
        },
      });
    }
    function addEvents() {
      _.addEvent({
        id: "newsletterModalMobileClose",
        event: "click",
        fn: closeMobileCta,
      });
    }
    function modalAfterClose() {
      setTimeout(() => {
        const clear = SDG.Modal.clear({
          modal: c.dom.modal_id,
          overlay: c.modal_overlay,
        });
        clear.init();
      }, 500);
    }
    function closeMobileCta() {
      _.addClass($mobileTrigger, c.cls.hide);
    }
    return { init };
  };

  /* --- newsletter.js --- */
  SDG.Newsletter = SDG.Newsletter || {};
  SDG.Newsletter.config = {
    cb: { form_success: null },
    cls: { loading: "is-loading", hasValue: "has-value" },
    dom: {
      btn: "newsletterSubmit",
      form: "newsletterForm",
      id: "newsletter",
      input: "newsletterInput",
    },
    hide_form_on_success: false,
    hide_messages_on_focus: false,
    hide_messages_on_success: true,
    message_opts: {
      id: "newsletterMessages",
      dom: { msg: "message message--nobg newsletter__message" },
      msgs: {
        already_member: "<p>You're already a member.</p>",
        success: "<p>Thanks for subscribing!</p>",
      },
    },
    namespace: null,
    placeholder: true,
    timer: { slide_up_delay: "3000", close_modal_delay: "4000" },
  };
  SDG.Newsletter.form = function (opts) {
    const c = _.extend(SDG.Newsletter.config, opts);
    c.dom = _.namespace(c.dom, c.namespace);
    c.message_opts = _.namespace(c.message_opts, c.namespace);
    const domId = document.getElementById(c.dom.id);
    const domForm = document.getElementById(c.dom.form);
    const domEmail = document.getElementById(c.dom.input);
    const domSubmit = document.getElementById(c.dom.btn);
    let msgs;
    function init() {
      msgs = SDG.Messages.init(c.message_opts);
      addEvents();
      callbacks();
    }
    function addEvents() {
      _.addEvent({ id: c.dom.form, event: "submit", fn: onSubmit });
      if (c.hide_messages_on_focus) {
        _.addEvent({ id: c.dom.form, event: "focus", fn: msgs.clear });
      }
    }
    function callbacks() {
      _.addEvent({
        id: c.dom.id,
        event: "formSuccess",
        fn: () => {
          if (typeof c.cb.form_success === "function") {
            setTimeout(() => {
              c.cb.form_success();
            }, c.timer.close_modal_delay);
          }
          if (c.hide_form_on_success) {
            _.hide(domForm);
          }
        },
      });
    }
    function onSubmit(e) {
      e.preventDefault();
      const ajaxUrl = this.getAttribute("data-ajax-submit");
      const data = _.serialize(domForm, true);
      disableButton();
      msgs.clear();
      domEmail.blur();
      _.ajax({
        contentType: "application/json",
        dataObject: JSON.stringify(data),
        error: onError,
        success: onSuccess,
        type: "POST",
        url: ajaxUrl,
      });
    }
    function onSuccess(response) {
      enableButton();
      clearInputs();
      if (response.already_member) {
        msgs.success(c.message_opts.msgs.already_member);
      } else {
        msgs.success();
      }
      if (domId) {
        _.trigger(domId, "formSuccess");
      }
      if (c.hide_messages_on_success) {
        setTimeout(msgs.clear, c.timer.slide_up_delay);
      }
      if (typeof c.cb.form_success === "function") {
        setTimeout(() => {
          c.cb.form_success();
        }, c.timer.close_modal_delay);
      }
    }
    function onError(response) {
      let errorMsg = response.message ? response.message.split(/\x2a/g) : null;
      enableButton();
      if (errorMsg) {
        errorMsg = `<p>${errorMsg[errorMsg.length - 1]}</p>`;
        msgs.error(errorMsg);
      } else {
        msgs.error();
      }
    }
    function enableButton() {
      _.removeClass(domSubmit, c.cls.loading);
      domSubmit.disabled = false;
    }
    function disableButton() {
      _.addClass(domSubmit, c.cls.loading);
      domSubmit.disabled = true;
    }
    function clearInputs() {
      domEmail.value = "";
      _.removeClass(domEmail.parentNode, c.cls.hasValue);
    }
    return init();
  };

  /* --- app-init-instant-load.js --- */
  // Assumes globalUi (instant) and loadScript utility are available.
  function browserSupportsAllFeatures() {
    return window.Promise && window.fetch;
  }
  function initInstantLoad() {
    const acceptedDomains = [
      "glamorise.com",
      "glamorise-staging.myshopify.com",
      "shopifypreview.com",
    ];
    const isAcceptedDomain = acceptedDomains.some(
      (domain) => window.location.hostname.indexOf(domain) !== -1
    );
    if (isAcceptedDomain) {
      if (browserSupportsAllFeatures()) {
        globalInstantLoadUi();
      } else {
        const src =
          "https://polyfill.io/v3/polyfill.min.js?features=Promise%2Cfetch";
        loadScript(src, globalInstantLoadUi);
      }
    }
  }
  initInstantLoad();

  /* --- app-init.js --- */
  // Assumes globalUi (full) and loadScript utility are available.
  function initApp() {
    if (browserSupportsAllFeatures()) {
      globalUi();
    } else {
      const src =
        "https://polyfill.io/v3/polyfill.min.js?features=Promise%2Cfetch";
      loadScript(src, globalUi);
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initApp);
  } else {
    initApp();
  }

  /* --- style-select.js --- */
  // Assumes styleSelect plugin is available globally.
  SDG.styleSelect = function (opts) {
    const config = { dom: { select: "select" }, options: { exclude: "hide" } };
    let view;
    const c = _.extend(config, opts);
    function init() {
      responsive();
      _.windowResize(responsive);
    }
    function responsive() {
      _.mq({
        view: "desktop",
        callback: () => {
          if (view !== "desktop") {
            initStyleSelect();
            view = "desktop";
          }
        },
      });
    }
    function initStyleSelect() {
      const $selects = document.querySelectorAll(c.dom.select);
      if ($selects) {
        $selects.forEach((select) => {
          if (!_.hasClass(select, c.options.exclude)) {
            styleSelect(select);
          }
        });
      }
    }
    return { init };
  };

  /* --- tabs.js --- */
  SDG.tabs = function (options) {
    const config = {
      dom: {
        button: "js-tab-button",
        content: "js-tab-content",
        id: "tabs",
        tabs: "js-tabs",
        tabsWrapper: "tabs",
      },
      cls: {
        active: "is-active",
        open: "is-open",
        multiButton: "has-multi-buttons",
      },
      tabList: null,
      defaultOpen: 0,
    };
    const c = _.extend(config, options);
    const $buttons = document.querySelectorAll(`.${c.dom.button}`);
    const $contents = document.querySelectorAll(`.${c.dom.content}`);
    function init() {
      addEvents();
      setDefaultOpenedTab();
      countVisibleButtons();
    }
    function addEvents() {
      _.addEvent({
        id: c.dom.id,
        event: "click",
        fn: toggleTab,
        className: c.dom.button,
      });
      if (c.tabList) {
        window.addEventListener("hashchange", () => {
          const urlHash = window.location.hash.replace(/#|-thanks/g, "");
          const tabToOpen =
            c.tabList.indexOf(urlHash) > -1 ? c.tabList.indexOf(urlHash) : null;
          _.scrollTo({
            target: c.dom.tabsWrapper,
            exec_now: true,
            offset: -200,
            callback: () => {
              setActive(tabToOpen);
            },
          });
        });
      }
    }
    function setDefaultOpenedTab() {
      if (c.defaultOpen === null) return;
      $buttons.forEach((button, index) => {
        if (index === c.defaultOpen) {
          _.addClass(button, c.cls.active);
          button.disabled = true;
        }
      });
      $contents.forEach((content, index) => {
        if (index === c.defaultOpen) {
          _.addClass(content, c.cls.open);
        }
      });
    }
    function countVisibleButtons() {
      const $tabs = document.querySelector(`.${c.dom.tabs}`);
      $buttons.forEach((button, index) => {
        if (index > 1) {
          _.addClass($tabs, c.cls.multiButton);
        }
      });
    }
    function toggleTab() {
      if (c.tabList) window.history.replaceState({}, "", "#");
      $buttons.forEach((button, index) => {
        if (this !== button) {
          _.removeClass(button, c.cls.active);
          button.disabled = false;
          $contents.forEach((content, menuIndex) => {
            if (index === menuIndex) {
              _.removeClass(content, c.cls.open);
            }
          });
        } else {
          toggleTabContent(this, index);
        }
      });
    }
    function toggleTabContent(activeButton, activeIndex) {
      const isActive = _.hasClass(activeButton, c.cls.active);
      if (!isActive) {
        _.addClass(activeButton, c.cls.active);
        activeButton.disabled = true;
        $contents.forEach((content, index) => {
          if (activeIndex === index) {
            _.addClass(content, c.cls.open);
          }
        });
      } else {
        _.removeClass(activeButton, c.cls.active);
        activeButton.disabled = false;
        $contents.forEach((content, index) => {
          if (activeIndex === index) {
            _.removeClass(content, c.cls.open);
          }
        });
      }
    }
    function setActive(tabIndex) {
      if (tabIndex === null) return;
      $buttons.forEach((button, index) => {
        if (index === tabIndex) {
          _.addClass(button, c.cls.active);
          button.disabled = true;
        } else {
          _.removeClass(button, c.cls.active);
          button.disabled = false;
        }
      });
      $contents.forEach((content, index) => {
        if (index === tabIndex) {
          _.addClass(content, c.cls.open);
        } else {
          _.removeClass(content, c.cls.open);
        }
      });
    }
    return { init, setActive };
  };

  /* --- test-panel.js --- */
  const testPanel = function () {
    const c = {
      dom: {
        bra_type_parent: ".js-bra-types",
        contact_parent: ".js-contact",
        email: ".js-email-input",
        form: "form316",
        messages: "messages",
        newsletter: ".js-newsletter-input",
        required: ".js-required",
        required_contact: ".js-required-contact",
        required_bras: ".js-required-bras",
        thanks: "thanks",
      },
      cls: { active: "active", hide: "hide", invalid: "invalid" },
      hash: { thanks: "thanks" },
      msg: { empty_value: "<p>Please fill out the required fields.</p>" },
      url: { newsletter: "https://klaviyo.sdg.la/v1/add/nadsbq" },
    };
    const $requiredBraTypes = document.querySelectorAll(c.dom.required_bras);
    const $braTypeParent = document.querySelector(c.dom.bra_type_parent);
    const $requiredContact = document.querySelectorAll(c.dom.required_contact);
    const $contactParent = document.querySelector(c.dom.contact_parent);
    const $email = document.querySelector(c.dom.email);
    const $form = document.getElementById(c.dom.form);
    const $newsletter = document.querySelector(c.dom.newsletter);
    const $messages = document.getElementById(c.dom.messages);
    function init() {
      addEvent();
      onSuccess();
    }
    function addEvent() {
      _.addEvent({ id: c.dom.form, event: "submit", fn: validate });
    }
    function validate(e) {
      e.preventDefault();
      const isRequiredValid = validateRequiredInputs();
      const isContactValid = validateCheckboxGroup(
        $requiredContact,
        $contactParent
      );
      const isBraTypesValid = validateCheckboxGroup(
        $requiredBraTypes,
        $braTypeParent
      );
      const isEmailValid = validateEmail();
      if (
        isRequiredValid === 0 &&
        isEmailValid &&
        isContactValid > 0 &&
        isBraTypesValid > 0
      ) {
        if ($newsletter.checked) newsletterSubmit();
        $form.submit();
      } else {
        $messages.innerHTML = c.msg.empty_value;
        _.removeClass($messages, c.cls.hide);
        _.scrollTo({
          id: c.dom.messages,
          exec_now: true,
          offset: -300,
          target: c.dom.messages,
        });
      }
    }
    function validateEmail() {
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if ($email && !regex.test($email.value)) {
        _.addClass($email.parentElement, c.cls.invalid);
      } else {
        _.removeClass($email.parentElement, c.cls.invalid);
      }
      return regex.test($email.value);
    }
    function validateRequiredInputs() {
      const $requiredInputs = document.querySelectorAll(c.dom.required);
      let isValid = 0;
      $requiredInputs.forEach((input) => {
        if (input.value === "") {
          _.addClass(input.parentElement, c.cls.invalid);
          isValid += 1;
        } else {
          _.removeClass(input.parentElement, c.cls.invalid);
        }
      });
      return isValid;
    }
    function validateCheckboxGroup(inputs, parent) {
      let isValid = 0;
      inputs.forEach((checkbox) => {
        if (checkbox.checked) {
          isValid += 1;
        }
      });
      if (isValid === 0) {
        _.addClass(parent, c.cls.invalid);
      } else {
        _.removeClass(parent, c.cls.invalid);
      }
      return isValid;
    }
    function onSuccess() {
      const $thanks = document.getElementById(c.dom.thanks);
      if (window.location.hash.indexOf(c.hash.thanks) !== -1) {
        _.addClass($thanks, c.cls.active);
      }
      _.scrollTo({
        id: c.dom.thanks,
        exec_now: true,
        offset: -300,
        target: c.dom.thanks,
      });
    }
    function newsletterSubmit() {
      const data = { email: $email.value };
      _.ajax({
        contentType: "application/json",
        dataObject: JSON.stringify(data),
        error: (response) => console.error(response),
        type: "POST",
        url: c.url.newsletter,
      });
    }
    return init();
  };
  SDG.testPanel = testPanel;
})();
